import { render, staticRenderFns } from "./FacilityContactCard.vue?vue&type=template&id=5859aed3&"
import script from "./FacilityContactCard.vue?vue&type=script&lang=js&"
export * from "./FacilityContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports